import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UnknownClass;
function Unknown() {
  if (UnknownClass === VOID) {
    class $ {
      constructor(message) {
        this.message_1 = message;
      }
      toString() {
        return 'Unknown(message=' + this.message_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.message_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Unknown()))
          return false;
        if (!(this.message_1 === other.message_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Unknown');
    UnknownClass = $;
  }
  return UnknownClass;
}
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var ApplyBoostCommandClass;
function ApplyBoostCommand() {
  if (ApplyBoostCommandClass === VOID) {
    class $ {
      constructor(partyId) {
        this.partyId_1 = partyId;
      }
      toString() {
        return 'ApplyBoostCommand(partyId=' + this.partyId_1.toString() + ')';
      }
      hashCode() {
        return this.partyId_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ApplyBoostCommand()))
          return false;
        if (!this.partyId_1.equals(other.partyId_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ApplyBoostCommand');
    ApplyBoostCommandClass = $;
  }
  return ApplyBoostCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher3ngwv5mtnm33a,
  Unknown as Unknown23h9hhg1mgr7w,
  ApplyBoostCommand as ApplyBoostCommand2h6i05q199ljk,
};
//endregion

//# sourceMappingURL=ApplyBoostCommand.mjs.map
